import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type CountResponse = {
  count: number;
};

type RequestParams = Pick<ApiQueryParams, 'limit'>;

export const getReportsCount = async (
  scope: RequestScope,
  { limit = 1000 }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<CountResponse>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<CountResponse>>(`/reports/count?limit=${limit}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
